import React from "react";
import { RotateCcw, X } from "lucide-react";
import { dakikaOnce } from "../lib/formDrafts";

// FAZ G — Form üstünde satır içi taslak teklifi. Otomatik geri yükleme YOK,
// kullanıcı her zaman onaylar.
export const DraftRestoreBar = ({ at, onRestore, onIgnore, testid = "draft-restore-bar" }) => (
  <div
    data-testid={testid}
    className="flex items-center justify-between gap-2 border border-amber-400/40 bg-amber-500/10 rounded-md px-2 py-1.5"
  >
    <div className="hud-text text-amber-200 leading-tight">
      Kaydedilmemiş taslağınız var ({dakikaOnce(at)})
    </div>
    <div className="flex items-center gap-1 shrink-0">
      <button
        type="button"
        onClick={onRestore}
        data-testid={`${testid}-restore`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded border border-amber-400/60 text-amber-200 hover:bg-amber-400/20 hud-text transition-colors"
      >
        <RotateCcw className="h-3 w-3" /> GERİ YÜKLE
      </button>
      <button
        type="button"
        onClick={onIgnore}
        data-testid={`${testid}-ignore`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded border border-sertex-cyan/25 text-sertex-textMuted hover:text-sertex-cyan hud-text transition-colors"
      >
        <X className="h-3 w-3" /> YOKSAY
      </button>
    </div>
  </div>
);

export default DraftRestoreBar;
